(function () {
    'use strict';

    angular
        .module('memories')
        .directive('xxMemoryList', xxMemoryList);

    function xxMemoryList() {
        return {
            restrict: 'E',
            templateUrl: 'app/memories/memory-list.html',
            controller: MemoryListCtrl,
            bindToController: true,
            controllerAs: 'vm',
            scope: { memories: '=value', outingId: '=?', groupId: '=?' },
        };
    }

    var some = Array.prototype.some,
        GROUP_ADMIN = 'http://schemas.golfnet.com/claims/canwritegroup',
        OUTING_ADMIN = 'http://schemas.golfnet.com/claims/canwriteouting';

    MemoryListCtrl.$inject = ['$scope', '$element', '$attrs', '$parse', '$q', '$uibModal', 'Memory', 'Member', 'progressHub',
        app.modules.common.services.functions, app.modules.common.services.storage];
    function MemoryListCtrl($scope, $element, $attrs, $parse, $q, $uibModal, Memory, Member, progressHub, ggFunctions, ggStorage) {
        var vm = this,
            progressModal;

        // Core
        vm.$onInit = init;
        vm.addMemory = addMemory;
        vm.editMemory = addMemory;

        // Child API
        vm.isAdministrator = false;
        vm.notifySaved = notifySaved;
        vm.notifyCancelled = notifyCancelled;
        vm.notifyEdit = notifyEdit;
        vm.notifyDeleted = notifyDeleted;
        vm.beginProgress = beginProgress;
        vm.endProgress = endProgress;

        // Display
        vm.isLoaded = false;
        vm.isEditMemory = isEditMemory;
        vm.isViewMemory = isViewMemory;
        vm.isOuting = isOuting;
        vm.showNoMemories = showNoMemories;

        //////////////////////////////////////////////

        // Core
        function init() {
            $scope.$on('$destroy', destroy);
            progressHub = progressHub();
            progressHub.on('progress', onProgress);
            setIsAdministrator();
            exposeWidget();

            vm.memories.$promise.finally(function () {
                vm.isLoaded = true;
            });

        }
        function destroy() {
            progressHub && progressHub.disconnect();
        }
        function addMemory() {
            var memory = new Memory({ outingId: vm.outingId, groupId: vm.groupId  });
            vm.memories.unshift(memory);
            editMemory(memory);
        }
        function editMemory(memory) {
            memory.$editing = true;
            vm.isEditing = true;
        }

        // Child API
        function notifyEdit(memory) {
            memory.$editing = true;
            vm.isEditing = true;
        }
        function notifySaved(memory) {
            memory.$editing = false;
            vm.isEditing = false;
        }
        function notifyCancelled(memory) {
            memory.$editing = false;
            vm.isEditing = false;
            if (!memory.id)
                removeMemoryFromList(memory);
        }
        function notifyDeleted(memory) {
            removeMemoryFromList(memory);
        }
        function beginProgress(key) {
            vm.progressLoaded = 0;
            vm.progressTotal = 1000;
            ggFunctions.toggleProcessing(false);
            progressModal = $uibModal.open({ templateUrl: 'progressModal.html', size: 'sm', backdrop: 'static', scope: $scope });
            return progressHub.subscribe(key);
        }
        function endProgress(key) {
            if (progressModal) {
                progressModal.close();
                progressModal = null;
            }
            return key ? progressHub.unSubscribe(key) : $q.resolve();
        }

        // Display
        function isEditMemory(memory) {
            return !isOuting(memory) && memory.$editing;
        }
        function isViewMemory(memory) {
            return !isOuting(memory) && !memory.$editing;
        }
        function isOuting(memory) {
            return angular.isDefined(memory.class);
        }
        function showNoMemories() {
            var memories = vm.memories,
                resolved = memories.$resolved;
            return !memories.length && (resolved == null || resolved)
        }

        // Helpers
        function removeMemoryFromList(memory) {
            var index = vm.memories.indexOf(memory);
            if (index != -1)
                vm.memories.splice(index, 1);
        }
        function onProgress(loaded, total) {
            vm.progressLoaded = loaded;
            vm.progressTotal = total;
        }

        function setIsAdministrator() {
            var claims = Member.getClaims({ id: ggStorage.get(ggStorage.keys.member.id) });
            return claims.$promise
                .then(some.bind(claims, predicate))
                .then(setProperty)
            
            function predicate(claim) {
                return (claim.type == GROUP_ADMIN && vm.groupId === +claim.value) ||
                    (claim.type == OUTING_ADMIN && vm.outingId === +claim.value);
            }

            function setProperty(value) {
                Object.defineProperty(vm, 'isAdministrator', { get: getter });
                function getter() { return value; }
            }
        }
        function exposeWidget() {
            var setter = $parse($attrs.name).assign;
            if (setter)
                setter($element.parent().scope(), vm);
        }
    }
})();